var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"label-unit-wrapper"},[_c('div',{class:[
    'label-unit-wrapper__wrapper',
    { [_vm.view]: _vm.isDefaultView },
    { 'disabled': _vm.disabled || _vm.isControlDisabled }
    ]},[(_vm.isLabel)?_c('div',{class:['label', { 'label-overflow': _vm.labelHideTextThatDoesNotFit }]},[_vm._t("label")],2):_vm._e(),(_vm.isValue)?_c('div',{staticClass:"value"},[_vm._t("value")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }